
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';

export default {
  name: 'Counter',
  props: {
    counter: {
      type: Number,
      default: 1,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    counterContent() {
      return new StyleClassNamesBuilder('counter__content')
        .addConditionClassName('active', this.isActive)
        .build();
    },
  },
};
